<div class="rating">
  <div class="rating-label">{{ 'product.rating' | transloco }}</div>
  <div class="rating-content">
    <ion-icon name="star" *ngFor="let i of product | affiliate: 'fullStars'"></ion-icon>
    <ion-icon name="star-half" *ngFor="let i of product | affiliate: 'halfStars'"></ion-icon>
    <ion-icon name="star-outline" *ngFor="let i of product | affiliate: 'emptyStars'"></ion-icon>
    ({{ product | affiliate: 'totalRatings' }})
  </div>
</div>
